import { Coupon } from "@/@types/cart"



export function controlStatus(coupon: Coupon) {
  if (coupon.end_date && new Date(coupon.end_date) < new Date()) {
    return 'expired'
  }

  return coupon.status
}